// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__13Yue","cardContent":"App_cardContent__2p6Mr"};